import { render, staticRenderFns } from "./brandNewIndex.vue?vue&type=template&id=3ec5dce7&scoped=true&"
import script from "./brandNewIndex.vue?vue&type=script&lang=js&"
export * from "./brandNewIndex.vue?vue&type=script&lang=js&"
import style0 from "./brandNewIndex.vue?vue&type=style&index=0&id=3ec5dce7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec5dce7",
  null
  
)

export default component.exports